import PropTypes from "prop-types";
import PaymentIdentityFieldset from "app/pages/Booking/Payment/PaymentIdentityFieldset";
import "./PaymentPassengersFieldset.scss";
import { PASSENGER_TYPE } from "app/constants";
import { FormattedDate, FormattedMessage } from "react-intl";
import DateSelectorInput from "app/pages/.shared/DateSelector/DateSelectorInput";
import FidelityCardNumberInputContainer from "app/pages/.shared/FidelityCardNumberInputContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const PaymentPassengersFieldset = ({
	passengers = [],
	isChildrenAgeRequired,
	dateOfBirthRequired,
	showFrequentTravellerCardInput,
	onBlur,
}) => {
	return (
		<div className="payment-passengers-fieldset">
			{passengers.map(
				(
					{ name, birthdate, type, frequentFlyerTravellerCardNumber, ...passenger },
					index
				) => {
					const dateNaissance = new Date(
						birthdate.year.value,
						birthdate.month.value,
						birthdate.day.value,
						15,
						0,
						0
					);

					let label = (
						<FormattedMessage
							id="payment.passengers.adult"
							values={{ index: passenger.index.value }}
						/>
					);

					if (type.value === PASSENGER_TYPE.CHILD) {
						label = isChildrenAgeRequired ? (
							<FormattedMessage
								id="payment.passengers.child.with.birthdate"
								values={{
									date: (
										<span className="payment-passengers-fieldset__birthdate-label">
											<FormattedDate
												value={dateNaissance}
												day="2-digit"
												month="long"
												year="numeric"
											/>
										</span>
									),
								}}
							/>
						) : (
							<FormattedMessage
								values={{ index: passenger.index.value }}
								id="payment.passengers.child"
							/>
						);
					} else if (type.value === PASSENGER_TYPE.INFANT) {
						label = isChildrenAgeRequired ? (
							<FormattedMessage
								id="payment.passengers.infant.with.birthdate"
								values={{
									date: (
										<span className="payment-passengers-fieldset__birthdate-label">
											<FormattedDate
												value={dateNaissance}
												day="2-digit"
												month="long"
												year="numeric"
											/>
										</span>
									),
								}}
							/>
						) : (
							<FormattedMessage
								values={{ index: passenger.index.value }}
								id="payment.passengers.infant"
							/>
						);
					}

					return (
						<div className="payment-passengers-fieldset__item" key={index}>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.LARGE}
								isBold
								className="payment-passengers-fieldset__title"
								component="h3"
								data-testid={`passenger-label-${type.value}-${index}`}
							>
								{label}
							</Typography>

							<PaymentIdentityFieldset
								fields={name}
								id={`passenger-${index}`}
								onBlur={onBlur}
							/>

							{type.value !== PASSENGER_TYPE.ADULT || dateOfBirthRequired ? (
								<div className="payment-passengers-fieldset__birthdate">
									<DateSelectorInput
										isRequired={true}
										isHidden={
											isChildrenAgeRequired &&
											(type.value === PASSENGER_TYPE.CHILD ||
												type.value === PASSENGER_TYPE.INFANT)
										}
										isChildrenAgeRequired={isChildrenAgeRequired}
										label={
											<FormattedMessage id="payment.pasengers.birthdate.label" />
										}
										fields={birthdate}
										id={`payment-passenger-child-${index}`}
										type={type.value}
										data-testid={`passenger-date-selector-${
											type.value
										}-${index}`}
									/>
								</div>
							) : (
								false
							)}

							{showFrequentTravellerCardInput && (
								<div className="payment-passengers-fieldset__frequent-flyer-traveller">
									<FidelityCardNumberInputContainer
										id={`passenger-${index}`}
										field={frequentFlyerTravellerCardNumber}
										onBlur={onBlur}
									/>
								</div>
							)}
						</div>
					);
				}
			)}
		</div>
	);
};

PaymentPassengersFieldset.propTypes = {
	passengers: PropTypes.array,
	onBlur: PropTypes.func,
	isChildrenAgeRequired: PropTypes.bool,
	dateOfBirthRequired: PropTypes.bool,
	showFrequentTravellerCardInput: PropTypes.bool,
};

export default PaymentPassengersFieldset;
